import { Menu, Typography } from '@neo4j-ndl/react';
import { MODAL_TYPE, useConnection, useModal } from '@nx/state';

import { ShowAll } from '../show-all/show-all';

interface Props {
  isMenuOpen: boolean;
  onClose: () => void;
  anchorEl?: React.RefObject<HTMLElement | null>;
}

export function UserMenu({ isMenuOpen, anchorEl, onClose }: Props) {
  const connection = useConnection();
  const passwordChangeModal = useModal(MODAL_TYPE.PASSWORD_CHANGE);

  return (
    <Menu isOpen={isMenuOpen} anchorRef={anchorEl} onClose={() => onClose()}>
      <Menu.Items>
        {connection.user?.roles && (
          <div className="ndl-menu-item ndl-disabled max-w-96 !cursor-default" role="menuitem" tabIndex={-1}>
            <Typography variant="body-medium" className="text-palette-neutral-text-weakest mr-1">
              Database roles:
            </Typography>
            <Typography variant="body-small" className="ml-1">
              <ShowAll initiallyShown={15}>
                {connection.user.roles.map((role, index, list) => (
                  <span key={role}>
                    {role}
                    {index !== list.length - 1 && ', '}
                  </span>
                ))}
              </ShowAll>
            </Typography>
          </div>
        )}
        <Menu.Item
          title="Change DB user password"
          isDisabled={connection.metadata?.credentials.type !== 'basic'}
          onClick={() => {
            passwordChangeModal.open({ passwordChangeRequired: false });
            onClose();
          }}
        />
      </Menu.Items>
    </Menu>
  );
}
